import { render, staticRenderFns } from "./likede.vue?vue&type=template&id=628925f6&scoped=true"
import script from "./likede.vue?vue&type=script&lang=js"
export * from "./likede.vue?vue&type=script&lang=js"
import style0 from "./likede.vue?vue&type=style&index=0&id=628925f6&prod&lang=scss"
import style1 from "./likede.vue?vue&type=style&index=1&id=628925f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628925f6",
  null
  
)

export default component.exports